// removed by extract-text-webpack-plugin
module.exports = {"main":"_2r0bHzuMWEIvS_bJIwY8NT"};


//////////////////
// WEBPACK FOOTER
// ./components/Login.module.css
// module id = 2359
// module chunks = 1